module.exports = "<!--Page Container-->\n<section class=\"main-container\">\n  <div class=\"container-fluid page-content\" style=\"display: flex; align-items: center; justify-content: center; min-height: calc(100vh - 120px);\">\n    <div class=\"text-center\">\n      <img [src]=\"logoPainelUrl ? logoPainelUrl : '/assets/img/logo_topbridge.png'\" alt=\"Logo\" class=\"img-responsive\" style=\"max-width: 600px; margin: 0 auto; opacity: 0.95; filter: drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.08));\">\n    </div>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main